module.exports = __webpack_public_path__ + "img/img-header-mobile.3b6f444.webp";